import shortid from "shortid";
import {
  Grid,
  CurrencyInput,
  TextFielDecimalNumbers,
  Select,
  MenuItem,
} from "../../../../components";

export default function ModeloTributacaoIcmsCombustivel({
  grupoModeloTributacao,
  handleInputChange,
  handleBlurChange,
  inputErros,
}) {
  const renderCombustivelImpostosForm = () => {
    switch (grupoModeloTributacao?.codigoCst) {
      case "15":
        return (
          <>
            <Grid item xs={4}>
              <CurrencyInput
                id="aliquotaAdrem"
                name="aliquotaAdrem"
                label="Alíquota ad rem do Imposto com retenção"
                variant="outlined"
                required
                value={grupoModeloTributacao?.aliquotaAdrem ?? "0"}
                onBlur={handleBlurChange}
                error={inputErros.get("aliquotaAdrem")}
              />
            </Grid>
            <Grid item xs={4}>
              <Select
                label={"Motivo da redução do adrem"}
                id="motivoReducaoAdrem"
                name="motivoReducaoAdrem"
                required
                disableClearable
                disabled={
                  !grupoModeloTributacao?.grupoTributarioId ? true : false
                }
                variant={
                  !grupoModeloTributacao?.grupoTributarioId
                    ? "filled"
                    : "outlined"
                }
                error={inputErros.get("motivoReducaoAdrem")}
                value={grupoModeloTributacao?.motivoReducaoAdrem || ""}
                onChange={handleInputChange}
                margin="normal"
              >
                <MenuItem key={shortid.generate()} value={"1"}>
                  1 - Transporte Coletivo de Passageiros
                </MenuItem>
                <MenuItem key={shortid.generate()} value={"9"}>
                  9 - Outros
                </MenuItem>
              </Select>
            </Grid>
            <Grid item xs={4}>
              <TextFielDecimalNumbers
                id="percentualReducaoAdrem"
                name="percentualReducaoAdrem"
                label="Percentual de redução da alíquota ad rem"
                margin="normal"
                onBlur={handleInputChange}
                value={grupoModeloTributacao?.percentualReducaoAdrem ?? ""}
                fullWidth
              />
            </Grid>
          </>
        );
      case "53":
        return (
          <>
            <Grid item xs={4}>
              <CurrencyInput
                id="aliquotaAdrem"
                name="aliquotaAdrem"
                label="Alíquota ad rem do Imposto Diferido"
                variant="outlined"
                required
                value={grupoModeloTributacao?.aliquotaAdrem ?? "0"}
                onBlur={handleBlurChange}
                error={inputErros.get("aliquotaAdrem")}
              />
            </Grid>
          </>
        );
      case "61":
        return (
          <>
            <Grid item xs={4}>
              <CurrencyInput
                id="aliquotaAdrem"
                name="aliquotaAdrem"
                label="Alíquota ad rem do Imposto Retido"
                variant="outlined"
                required
                value={grupoModeloTributacao?.aliquotaAdrem ?? "0"}
                onBlur={handleBlurChange}
                error={inputErros.get("aliquotaAdrem")}
              />
            </Grid>
          </>
        );
      default:
        return (
          <>
            <Grid item xs={4}>
              <CurrencyInput
                id="aliquotaAdrem"
                name="aliquotaAdrem"
                label="Alíquota ad rem do Imposto"
                variant="outlined"
                required
                value={grupoModeloTributacao?.aliquotaAdrem ?? "0"}
                onBlur={handleBlurChange}
                error={inputErros.get("aliquotaAdrem")}
              />
            </Grid>
          </>
        );
    }
  };

  return (
    <Grid container spacing={2}>
      {renderCombustivelImpostosForm()}
    </Grid>
  );
}
